/**
 * PROMO BUTTONS — added BELOW the existing buttons of one named step.
 *
 * It renders nothing at all unless a live promo names the step it is given,
 * so every existing button, the public review step and the private feedback
 * option are untouched. One request per visit, no counters, no visitor data.
 */
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${(typeof window !== 'undefined' ? window.location.origin : '')}/api`;
const MAX_PER_STEP = 2;

export const PromoButtons = ({ cardId, step, lang = 'en' }) => {
    const [buttons, setButtons] = useState([]);

    useEffect(() => {
        if (!cardId) return undefined;
        let alive = true;
        axios.get(`${API}/public/promo-buttons/${cardId}`, { params: { lang } })
            .then((r) => { if (alive) setButtons(r.data.buttons || []); })
            .catch(() => { if (alive) setButtons([]); });
        return () => { alive = false; };
    }, [cardId, lang]);

    const here = buttons.filter((b) => b.step === step && b.link && b.text)
        .slice(0, MAX_PER_STEP);
    if (!here.length) return null;

    return (
        <div className="mt-3 space-y-2" data-testid={`promo-buttons-${step}`}>
            {here.map((b) => (
                <a key={b.id} href={b.link} target="_blank" rel="noopener noreferrer"
                   data-testid={`promo-button-${b.id}`}
                   className="block w-full rounded-full px-5 py-3 text-center text-base font-semibold
                              transition-transform duration-150 active:scale-[0.98]"
                   style={{ background: b.bg_color, color: b.text_color }}>
                    {b.text}
                </a>
            ))}
        </div>
    );
};
